/**
 * Convert a CRM version string to a number that orders like the versions do.
 *
 * Two shapes are accepted, optionally with a leading `v`:
 *
 * - Legacy semver `X.Y.Z`, up to two digits each: `5.19.14` -> 51914. This is
 *   the value the original implementation produced
 *   (https://github.com/elidupuis/semver2int), unchanged.
 * - Release versions `X.N` (CRMDEV-7523), two components like bonliva-erp's
 *   `1.41064`, where N is a counter that continued from the last semver
 *   release: `5.1915` -> 51915, so every new version sorts after every old one.
 *
 * A two-component version whose counter has one or two digits (`5.19`) reads as
 * `X.Y.0`. Anything else returns -1.
 */
export function semverToInt(semver: string) {
  const parts = /^v?(\d{1,2})\.(\d{1,4})(?:\.(\d{1,2}))?(?!\d|\.)/i.exec(semver ?? "");

  if (!parts) {
    return -1;
  }

  const major = +parts[1];
  const minor = +parts[2];
  const patch = parts[3] === undefined ? 0 : +parts[3];

  // A release counter (three or more digits) already encodes minor and patch.
  if (parts[2].length > 2) {
    return parts[3] === undefined ? major * 10000 + minor : -1;
  }

  return major * 10000 + minor * 100 + patch;
}
